import { useCallback, useEffect, useState } from "react";
import { Button, Col, Container, Form, Row, Spinner } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import useFetch from "../../../../hooks/useFetch";

//interfaces
import { FuncionInterface } from "../../../../interfaces/FuncionInterface";
import ForbiddenMessage from "../../../Mensajes/ForbiddenMessage";
import SuccessMessage from "../../../Mensajes/SuccessMessage";
import ServerMessage from "../../../Mensajes/ServerMessage";

//estilos
const classes = require("./FuncionEdit.module.css").default;

/**
 * UusarioEdit Component
 * @description: Componente que permite editar un funcion.
 * @date 6/12/2022.
 * @param Props Ninguno
 * @returns JSX de la tabla de funcions.
 */

const FuncionEdit = () => {
  const { idFuncion } = useParams();
  const { sendRequest, error, setError, serverMessage, setServerMessage } =
    useFetch();
  const [funcion, setFuncion] = useState<FuncionInterface>();
  const [show, setShow] = useState(false);

  //Variables de formulario
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      nombre: funcion?.nombre,
    },
  });

  //Función que trata el detalle de funcion.
  const transformData = useCallback(
    (variable: any) => {
      setFuncion(variable.data);
      reset(variable.data);
    },
    [reset]
  );

  //Se recibe el funcion a editar
  useEffect(() => {
    sendRequest(
      {
        url: `/funcion/${idFuncion}`,
      },
      transformData
    );
  }, [idFuncion, sendRequest, transformData]);

  //Función que solicita la edición del funcion
  const updateFuncion = (data: any) => {
    sendRequest(
      {
        url: `/funcion/${idFuncion}`,
        method: "PATCH",
        body: data,
      },
      (variable: any) => {
        setShow(true);
      }
    );
  };

  //Mientras se carga el contenido se muestra un spinner
  if (!funcion) {
    return (
      <div className={classes.spinnerContainer}>
        <Spinner animation="grow" variant="info" />
      </div>
    );
  }

  return (
    <Container>
      <h2>Edición de la funcion {idFuncion}</h2>
      {show && (
        <SuccessMessage
          header="Función actualizada"
          body="La función ha sido actualizada de manera correcta."
          onCloseHandler={() => setShow(false)}
        />
      )}
      {/** Error del servidor */}
      {serverMessage && (
        <ServerMessage
          message={serverMessage}
          onCloseHandler={() => setServerMessage(undefined)}
        />
      )}
      {error === 403 && (
        <ForbiddenMessage onCloseHandler={() => setError(null)} />
      )}
      {/** Formulario */}
      <Form onSubmit={handleSubmit(updateFuncion)}>
        <Row className="mb-3">
          <Form.Group as={Col} md="12" className="mb-3">
            <Form.Label>Nombre</Form.Label>
            <Controller
              name="nombre"
              control={control}
              rules={{
                required: true,
                maxLength: 50,
              }}
              render={({ field }) => {
                return (
                  <Form.Control
                    {...field}
                    onChange={(e) =>
                      field.onChange(e.target.value.toUpperCase())
                    }
                  />
                );
              }}
            />
            {errors.nombre && (
              <Form.Text style={{ color: "red" }}>
                El nombre es obligatorio y no puede ser mayor a 50 caracteres.
              </Form.Text>
            )}
          </Form.Group>
        </Row>

        <Button
          style={{
            backgroundColor: "#21618C",
            borderColor: "white",
          }}
          type="submit"
        >
          Guardar cambios
        </Button>
      </Form>
    </Container>
  );
};

export default FuncionEdit;
